import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu as MenuIcon, X } from "lucide-react";
import { Logo } from "./Logo";

const links = [
  { label: "Home", href: "/#home" },
  { label: "Story", href: "/#story" },
  { label: "Menu", href: "/#menu" },
  { label: "Gallery", href: "/#gallery" },
  { label: "Reviews", href: "/#reviews" },
  { label: "Contact", href: "/#contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-border/60 bg-charcoal/85 backdrop-blur-xl">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 md:px-10">
        <Link to="/" data-testid="nav-home-logo">
          <Logo compact />
        </Link>

        <div className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm text-cream/70 transition-colors duration-200 hover:text-caramel"
            >
              {l.label}
            </a>
          ))}
          <Link
            to="/menu"
            data-testid="nav-full-menu-btn"
            className="rounded-full border border-copper bg-copper px-5 py-2 text-sm font-semibold text-charcoal transition-colors duration-200 hover:bg-caramel"
          >
            Full Menu
          </Link>
        </div>

        <button
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle navigation"
          className="rounded-full border border-border p-2 text-cream md:hidden"
        >
          {open ? <X className="h-5 w-5" /> : <MenuIcon className="h-5 w-5" />}
        </button>
      </nav>

      {open && (
        <div className="border-t border-border/60 px-5 pb-5 md:hidden" data-testid="nav-mobile-panel">
          <div className="flex flex-col gap-1 pt-3">
            {links.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className="rounded-md px-2 py-2.5 text-sm text-cream/80 transition-colors duration-200 hover:bg-coffee hover:text-caramel"
              >
                {l.label}
              </a>
            ))}
            <Link
              to="/menu"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-full-menu"
              className="mt-2 rounded-full bg-copper px-4 py-2.5 text-center text-sm font-semibold text-charcoal"
            >
              Full Menu
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};
